const Fonts = {
	montserratBold: 'Montserrat-Black',
	montserratMedium: 'Montserrat-Medium',
	montserratRegular: 'Montserrat-Regular',
	montserratLight: 'Montserrat-Light',
	montserratLightItalic: 'Montserrat-LightItalic',
};

export default Fonts;
